import PropTypes from 'prop-types'
import React from 'react'
import '../styles/components/loader.scss'

export const LoadingSpinner = ({ size, className }) => {
    return (
        <div>
            <div className="loader"></div>
        </div>

    )
}

LoadingSpinner.propTypes = {
    size: PropTypes.number,
    className: PropTypes.string
}

LoadingSpinner.defaultProps = {
    size: 1
}

export default LoadingSpinner;
